<template>
  <div>  

    <!--<v-tooltip top dark color="grey darken-3">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          color="success darken-2"
          dark
          absolute
          top
          right
          fab
          x-small
          @click.stop="mostrarTimeLine = !mostrarTimeLine"
        >
          <v-icon>mdi-timeline-clock-outline</v-icon>
        </v-btn>
      </template>
      <span class="white--text text--darken-4 subtitle-2">Timeline Status</span>
    </v-tooltip> -->

    <v-navigation-drawer
      v-model="mostrarTimeLine"
      absolute
      temporary
      class="px-0 mx-0"
      width="450px"
    >

      <v-list-item>

        <v-list-item-content>
          <v-list-item-title class="font-weight-black subtitle-1">TimeLine Status Processo</v-list-item-title>
        </v-list-item-content>
        <v-btn
          color="success darken-2"
          fab
          dark
          x-small
          @click="fechar"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>
      
      <v-timeline>
        <v-timeline-item small v-for="(item, index) in processoStatus" :key="item.id">
          <span class="subtitle-2"> {{item.ds_situacao}} </span><br>
          <span class="caption"> {{item.updated_at | datahora}} </span><br>  
          <span class="caption"> {{item.ds_email}} </span>
        </v-timeline-item>
      </v-timeline>

    </v-navigation-drawer>

  </div>
</template>

<script>

import apiClient from '@/plugins/axios'


export default {
  name: 'TimeLineStatusProcesso',
  props: ['processo_id', 'mostrar'],
  data() {
    return {
      //mostrarTimeLine: false,
      processoStatus: [],
    }
  },
  created() {
    this.atualizarProcessoStatus(this.processo_id) 
  },
  methods: {
    fechar() {
      this.$emit('fechar')
    },
    atualizarProcessoStatus(id) {
      if (!(id>0)) return
      apiClient.get(`processostatus/${id}`)
      .then(response => {
        if (response.data.status) {
          this.processoStatus = response.data.processo_status
        }
      })
      .catch(error => {
        console.log(error)
        //reject(error)
      })
    }
  },
  watch: {
    processo_id(newVal){
      this.atualizarProcessoStatus(newVal)
    },
  },
  computed:{
    mostrarTimeLine: {
      get: function() {
        return this.mostrar
      },
      set(newVal) {
        if (!newVal) this.$emit('fechar')
        return newVal
      }
    },
  }
}
</script>
<style scoped>
  .v-btn--absolute.v-btn--top, .v-btn--fixed.v-btn--top {
    top: 5px !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/Processo/TimeLineStatus.vue